import React, { useContext, useState } from "react";
import { BsChatDots } from "react-icons/bs";
import { FaArrowLeftLong } from "react-icons/fa6";
import footerImage from "../../images/OrviLogo2.png";
import iconMobile from "../../images/iconMobile.png";
import { useNavigate } from "react-router-dom";
import StaggeredDropDown from "./HistoryButton";
import { clearSession, clearSessionId } from "../../utils/storage";
import { logout } from "../../api/authApi";
import AuthContext from "../../context/AuthContext";

function MobileSidebar() {
  const [isHistoryClicked, setIsHistoryClicked] = useState(false);
  const { dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleHistoryClick = () => {
    setIsHistoryClicked((prevState) => !prevState);
  };
  const handleLogout = async () => {
    try {
      await logout();
      dispatch({ type: "LOGOUT" });
      clearSession();
      clearSessionId();
      navigate("/login");

    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const handleNewChat = () => {
    navigate("/");
  };

  return (
    <div className="navbar bg-purpleColorSecond w-full z-30 relative ">
      <div className="flex justify-around items-center pt-6">
        <div>
          <img src={iconMobile} className="w-10 md:w-12" alt="Mobile Icon" />
        </div>
        <div>
          <img src={footerImage} className="w-36 md:w-48" alt="Footer Icon" />
        </div>
      </div>
      <div className="flex justify-around items-center gap-4 bg-darkPurple p-2 m-3 text-white rounded-lg">
        <button onClick={handleLogout}>
          <div className="flex justify-center py-1">
            <FaArrowLeftLong style={{ fontSize: "24px" }} />
          </div>
          <h6 className="text-sm md:text-xl">Logout</h6>
        </button>
        <button onClick={handleHistoryClick}>
          <StaggeredDropDown />
        </button>

        <button onClick={handleNewChat}>
          <div className="flex justify-center py-1">
            <BsChatDots style={{ fontSize: "24px" }} />
          </div>
          <h6 className="text-sm md:text-xl">New Chat</h6>
        </button>
      </div>
    </div>
  );
}

export default MobileSidebar;


